import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Card, Container, ContainerFlex, SelectItemInput, TextLocalized } from '../components/styled/Styled';

import { getTextLang, LanguageContext } from '../components/providers/LanguageProvider';
import { HttpConnection, HttpMethod, HttpOperations } from '../components/util/HttpConnection';
import GoodPracticeTypeItem from '../components/GoodPracticeTypeItem';

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const BussinessCasesList = () => {
    const [formData, setFormData] = useState({ block: "", difficulty: "", businessDynamics: "", businessFactors: "" });
    const formRef = useRef(formData);

    const [categories, setCategories] = useState({ blocks: [], difficulties: [], businessDynamics: [], businessFactors: [] });

    const [items, setItems] = useState([]);
    const { language, dictionary } = useContext(LanguageContext);

    const query = useQuery();

    useEffect(() => {
        const block = query.get('block') ?? "";
        const difficulty = query.get('difficulty') ?? "";
        const businessDynamics = query.get('businessDynamics') ?? "";
        const businessFactors = query.get('businessFactors') ?? "";

        //Get gategories
        HttpConnection(HttpOperations.categories,
            response => {
                if (block !== "") {
                    response.item.blocks.forEach(item => {
                        if (item.id_block == block) {
                            formRef.current = { ...formRef.current, block: getTextLang(item, 'name', language) };
                            setFormData({ ...formRef.current });
                        }
                    })
                }
                setCategories(response.item);
            }, error => console.log(error), HttpMethod.get)

        //Get strategies
        HttpConnection(`${HttpOperations.block}/groups?block=${block}&difficulty=${difficulty}&businessDynamics=${businessDynamics}&businessFactors=${businessFactors}`,
            response => {
                setItems(response.item)
            }, error => console.log(error), HttpMethod.get);
    }, [query])

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const submitFilter = () => {
        let block = "";
        let difficulty = "";
        let businessDynamics = "";
        let businessFactors = "";


        if (formData.block !== "") {
            categories.blocks.forEach(item => {
                if (getTextLang(item, 'name', language) === formData.block)
                    block = item.id_block;
            })
        }

        if (formData.difficulty !== "") {
            categories.difficulties.forEach(item => {
                if (getTextLang(item, 'name', language) === formData.difficulty)
                    difficulty = item.id_difficulty;
            })
        }

        if (formData.businessDynamics !== "") {
            categories.businessDynamics.forEach(item => {
                if (getTextLang(item, 'name', language) === formData.businessDynamics)
                    businessDynamics = item.id_business_dynamics;
            })
        }

        if (formData.businessFactors !== "") {
            categories.businessFactors.forEach(item => {
                if (getTextLang(item, 'name', language) === formData.businessFactors)
                    businessFactors = item.id_business_factors;
            })
        }

        HttpConnection(`${HttpOperations.block}/groups?block=${block}&difficulty=${difficulty}&businessDynamics=${businessDynamics}&businessFactors=${businessFactors}`,
            response => {
                setItems(response.item)
            }, error => console.log(error), HttpMethod.get);
    }

    return (
        <ContainerFlex width="12" justify="center" px="32" color="color-gray" minheight="100vh">
            <Container width="12" lg="8">
                <Card width="12" shadowOn flex mv="16" align="center" color="color-green-dark" fontColor="color-white">
                    <Container width="12" ph="16" mt="16" fontSize="18px" fontWeight="300" children={<TextLocalized children="msgHeader1" />} />
                    <Container width="12" mh="16" mt="8" mb="16" fontSize="12px" children={<TextLocalized children="msgStrategiesSubtitle" />} />

                    <Card flex ph="16" color="color-white" width="12" align="stretch" radiustl="0" radiustr="0">
                        <SelectItemInput onChange={onChange} placeholder={dictionary["msgLifecyclePhase"]} title={"msgLifecyclePhase"} options={categories.blocks.map(item => getTextLang(item, 'name', language))} inputmv="16" inputmr="8" titleph="16" name="block" value={formData.block} />
                        <SelectItemInput onChange={onChange} placeholder={dictionary["msgDifficulty"]} title={"msgDifficulty"} options={categories.difficulties.map(item => getTextLang(item, 'name', language))} inputmv="16" inputmr="8" titleph="16" name="difficulty" value={formData.difficulty} />
                        <SelectItemInput onChange={onChange} placeholder={dictionary["msgBusinessDynamics"]} title={"msgBusinessDynamics"} options={categories.businessDynamics.map(item => getTextLang(item, 'name', language))} inputmv="16" inputmr="8" titleph="16" name="businessDynamics" value={formData.businessDynamics} />
                        <SelectItemInput onChange={onChange} placeholder={dictionary["msgBusinessFactors"]} title={"msgBusinessFactors"} options={categories.businessFactors.map(item => getTextLang(item, 'name', language))} inputmv="16" inputmr="8" titleph="16" name="businessFactors" value={formData.businessFactors} />

                        <Button onClick={submitFilter} flex align="center" mv="16" ph="32" pv="8" color="color-primary" hoverColor="color-primary-a40"
                            fontColor="color-black" fontWeight="bold" textAlign="center"
                            children={<TextLocalized children="actionFilter" />} />
                    </Card>
                </Card>

                <ContainerFlex width="12" align="stretch">
                    {
                        items.map((item) => {
                            return <Fragment key={item.id_block}>
                                <Card align="center" mt="32" mb="16" ph="16" pv="8" fontSize="18px" fontWeight="300" color={"color-primary"}
                                    fontColor="color-black" children={getTextLang(item, 'name', language)} />
                                {item.groups.map((group) => <GoodPracticeTypeItem key={group.id_group} item={group} />)}
                            </Fragment>
                        })
                    }
                </ContainerFlex>
            </Container>
        </ContainerFlex>
    );
};

export default BussinessCasesList;